import React, { useState } from 'react';
import { api } from '../api/models';

export default function Login({ onLoginSuccess }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isHovered, setIsHovered] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        
        const success = await api.login(password);
        if (success) {
            onLoginSuccess();
        } else {
            setError("❌ Password errata. Riprova.");
        }
    };

    // --- STILI AGGIORNATI (DARK MODE) ---
    const styles = {
        container: { 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh', 
            backgroundColor: '#0f172a', // Sfondo scuro profondo
            fontFamily: "'Inter', sans-serif"
        },
        form: { 
            padding: '2.5rem', 
            backgroundColor: '#1e293b', // Card leggermente più chiara
            borderRadius: '16px', 
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5)', 
            textAlign: 'center',
            width: '100%',
            maxWidth: '400px',
            border: '1px solid #334155'
        },
        title: {
            color: '#60a5fa',
            margin: '0 0 10px 0',
            fontSize: '24px',
            fontWeight: '700'
        },
        subtitle: {
            color: '#94a3b8',
            fontSize: '14px',
            marginBottom: '20px'
        },
        input: { 
            width: '100%', 
            padding: '12px 16px', 
            margin: '15px 0', 
            borderRadius: '8px', 
            border: '1px solid #475569',
            backgroundColor: '#0f172a',
            color: '#f1f5f9',
            fontSize: '16px',
            outline: 'none',
            boxSizing: 'border-box',
            transition: 'border-color 0.2s',
            // Quando selezionato cambia bordo (simulato)
            ':focus': { borderColor: '#3b82f6' } 
        },
        button: { 
            width: '100%', 
            padding: '12px', 
            backgroundColor: isHovered ? '#2563eb' : '#3b82f6', 
            color: 'white', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            transition: 'all 0.2s ease',
            transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
            boxShadow: isHovered ? '0 10px 15px -3px rgba(59, 130, 246, 0.4)' : 'none'
        },
        error: { 
            color: '#fb7185', 
            marginTop: '15px',
            fontSize: '14px',
            fontWeight: '500'
        }
    };

    return (
        <div style={styles.container}>
            <form onSubmit={handleSubmit} style={styles.form}>
                <h2 style={styles.title}>⚡ Light Boost</h2>
                <p style={styles.subtitle}>Inserisci la chiave d'accesso per il server.</p>
                
                <input 
                    type="password" 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password di sistema"
                    style={styles.input}
                    autoFocus
                />
                
                <button 
                    type="submit" 
                    style={styles.button}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    Entra nella Dashboard
                </button>

                {error && <p style={styles.error}>{error}</p>}
            </form>
        </div>
    );
}